import "./App/store";
import "./App/firebase";
import "./App/dateformat";
import "./utils/api";
import "./addons/SystemStatus";
import "./index.css";

import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { mergeStyles, ThemeProvider } from "@fluentui/react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import React from "react";

import { App } from "./App";
import { store } from "./App/store";
import reportWebVitals from "./reportWebVitals";
import { theme } from "./utils/theme";
import ServerRendererComponent from "./Components/Forms/PdfDocument/ServerRendererComponent";

initializeIcons();

// Inject some global styles
mergeStyles({
  ":global(body,html,#root)": {
    margin: 0,
    padding: 0,
    height: "100vh",
    backgroundColor: theme.palette.neutralLighterAlt,
    "@media print": {
      backgroundColor: "white",
    },
  },
  ":global(::selection)": {
    color: "#fff",
    backgroundColor: theme.palette.themePrimary,
  },
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      {window.location.pathname === "/render-pdf" ? (
        <ServerRendererComponent />
      ) : (
        <App />
      )}
    </ThemeProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
